import React, { Suspense, useEffect } from 'react';
import { RTLLayout } from './components/RTLLayout';
import { ConfigProvider } from './providers/ConfigProvider';
import { ThemeProvider } from './providers/ThemeProvider';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { ToastProvider } from './providers/ToastProvider';
import { useAuthStore } from './store/auth.store';
import { Box } from '@mui/material';

function App() {
  const { initializeAuth } = useAuthStore();

  useEffect(() => {
    initializeAuth();
  }, []);

  return (
    <ConfigProvider>
      <RTLLayout>
        <ThemeProvider>
          <ToastProvider>
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
              <Suspense fallback={<></>}>
                <RouterProvider router={router} />
              </Suspense>
            </Box>
          </ToastProvider>
        </ThemeProvider>
      </RTLLayout>
    </ConfigProvider>
  );
}

export default App;
